module.exports = __webpack_public_path__ + "static/media/Weapon_01.f5176be8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GameTheme/WeaponComponent/Weapon_01.png
// module id = 1383
// module chunks = 0